import { LoadViewTable } from "#common/LoadingView"
import ErrorResponse from "#common/pages/ErrorResponse"
import MainDetailsFooter from "#core/components/main-details/MainDetailsFooter"
import { useApi } from "#hooks/useApi"
import VacancyDetailsAccordion from "#vacancy/components/vacancy-details/VacancyDetailsAccordion"
import VacancyDetailsBody from "#vacancy/components/vacancy-details/VacancyDetailsBody"
import VacancyDetailsHead from "#vacancy/components/vacancy-details/VacancyDetailsHead"
import { useSetVacancy } from "#vacancy/redux/actions"
import { useVacanteRedux } from "#vacancy/redux/slice"
import { vacanteGet } from "#vacancy/services/api"
import { Paper } from "@mui/material"
import Box from "@mui/material/Box"
import { createContext, useMemo } from "react"

export const ContextVacante = createContext()

export default function VacancyDetails({ vacanteId }) {
	const { reload } = useVacanteRedux()
	const params = useMemo(() => vacanteId, [vacanteId])
	const {
		data: dataVacante,
		loading,
		error,
	} = useApi(vacanteGet, { params, autoFetch: !!vacanteId, reload })
	useSetVacancy(dataVacante)

	if (error) return <ErrorResponse error={error} />
	if (loading) return <LoadViewTable />

	return (
		<Box component={Paper} display={"flex"} flexDirection={"column"} gap={1}>
			<VacancyDetailsHead vacancy={dataVacante} />
			<VacancyDetailsBody vacante={dataVacante} />
			<VacancyDetailsAccordion vacancy={dataVacante} />
			<MainDetailsFooter data={dataVacante} noUsePaper />
		</Box>
	)
}
